const Country = "Country";
const Indicator = "Indicator";
const Chart = "Chart";
const BarChartStr = "Bar Chart";
const LineChartStr = "Line Chart";
const BillionStr = "Billion";
const TrillionStr = "Trillion";
const MillionStr = "Million";
const oneHundredThousandStr = "Thousand";
const dateAscendingOrder = "date ascending order";
const dateDescendingOrder = "date descending order";
const valueAscendingOrder = " value ascending order";
const valueDescendingOrder = " value descending order";
const first20 = "first20";
const next20 = "next20";
const noData = "No Data";

export {
  Country,
  Indicator,
  Chart,
  BarChartStr,
  LineChartStr,
  BillionStr,
  TrillionStr,
  MillionStr,
  oneHundredThousandStr,
  dateAscendingOrder,
  dateDescendingOrder,
  valueAscendingOrder,
  valueDescendingOrder,
  first20,
  next20,
  noData,
};
